export const referenceNames = {
  points10DaysBeforeLastDayOfMonth: `points-10-days-before-last-day-of-month`,
  yearPointsGreaterThen0: `year-points-greater-then-0`,
  getSevenDaysBeforeWithNoProgressReports: `getSevenDaysBeforeWithNoProgressReports`,
  allChildrenProgressReportsCompleted: `allChildrenProgressReportsCompleted`,
  allChildrenProgressReportsCreated: `allChildrenProgressReportsCreated`,
  lessThenAllChildrenWithProgressReports: `lessThenAllChildrenWithProgressReports`,
  pastDeadlineDateForProgressReports: `pastDeadlineDateForProgressReports`,
};
